module.exports = __webpack_public_path__ + "static/media/IMG_3071.45127ffa.JPG";